/*
    Most forms are auto-submitted via AJAX.
    To disable auto submit for a particular form, you can:
        a) add 'disable-auto-submit' class to the form
        b) add the form's selector to the blacklist
*/

import $ from 'jquery';
import ajax from 'util/ajax';
import { $body, $window, jqOffOn } from 'util/global';


const SELECTOR_BLACKLIST = [
    '[action*="account/"]',
    '[action*="avatar/"]',
];


/**
 * Auto disable forms, prevent submitting more than once.
 * @param {JQuery} $forms
 */
export function preventDefaultSubmitHandler($forms) {
    $forms.each((i, form) => {
        const $form = $(form);
        const submitEventHandlers = [];
        let submitBindings = [];

        // eslint-disable-next-line no-underscore-dangle
        const { events } = $._data(form);

        if (events) {
            submitBindings = events.submit || [];
            submitBindings = submitBindings.slice(0);
        }

        if (form.onsubmit) {
            submitEventHandlers.push(form.onsubmit);
        }

        submitBindings.forEach((binding) => {
            submitEventHandlers.push(binding.handler);
        });

        const handler = (e) => {
            const formElement = e.target;
            const defaultPrevented = !!(e.isDefaultPrevented && e.isDefaultPrevented());
            let fail = false;

            submitEventHandlers.forEach((submitEventHandler) => {
                try {
                    formElement.next_handler = submitEventHandler;
                    if (formElement.next_handler(e) === false) {
                        fail = true;
                    }
                } catch (err) {
                    // do nothing
                }
            });

            if (!fail && !defaultPrevented) {
                jqOffOn($form, 'submit', (event) => {
                    event.preventDefault();
                });
                jqOffOn($window, 'pageshow.auto_disable', (event) => {
                    if (event.originalEvent.persisted) {
                        jqOffOn($form, 'submit', handler);
                    }
                });
            }
            return !fail;
        };

        form.onsubmit = () => {};
        jqOffOn($form, 'submit', handler);
    });
}


/**
 * Searches the scope for forms and adds auto_submit event
 * @param {JQuery} [$scope] - <BODY> by default
 */
export function initAutosubmit($scope = $body) {
    if (window.django) {
        // this breaks the admin site
        return;
    }

    $scope.find('form').each((i, form) => {
        const $form = $(form);

        if ($form.is(`:not(.disable-auto-submit, ${SELECTOR_BLACKLIST.join(',')})`)) {
            jqOffOn($form, 'submit.auto_submit', (e) => {
                e.preventDefault();
                ajax('assessment').form(e.currentTarget);
            });

            if ($form.not('.disable-submit-auto-disabling')) {
                preventDefaultSubmitHandler($form);
            }
        }
    });
}
